import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';

const UstkInwView = () => {


    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setTableData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);

    console.log(tableData)


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };



    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Inward View</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                

                                {Array.isArray(tableData?.info) && tableData?.info.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Select.</TableCell> */}
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Color</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Stock Qty</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sale Rate</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Discount Rate</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData?.info?.length > 0
                                                        ? tableData?.info?.map((form, index) => (
                                                            <TableRow key={index}>
                                                                {/* <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows?.has(index)}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                </TableCell> */}
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.size}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.color}</TableCell>

                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.bqty}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.srate}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disrate}</TableCell>
                                                                {/* <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <input type="text"
                                                                        value={form.salerate || ''}
                                                                        name='salerate'
                                                                        onChange={(e) => handleChange(index, 'salerate', e.target.value)}
                                                                        style={{ height: '25px', width: '60px' }}
                                                                    />
                                                                 
                                                                </TableCell> */}
                                                            </TableRow>
                                                        ))
                                                        : ''}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>



                                    </>
                                }

                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UstkInwView;
